var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.448 5.987 C 11.438 6.119 10.908 12.265 10.908 12.265 C 10.854 12.758 10.676 13.112 10.434 13.343 C 10.194 13.572 9.853 13.718 9.399 13.726 L 9.397 13.726 C 9.239 13.73 5.135 13.745 4.304 13.726 C 3.875 13.715 3.541 13.569 3.303 13.337 C 3.062 13.103 2.886 12.748 2.836 12.266 C 2.836 12.266 2.746 11.23 2.64 10.019 C 2.492 8.324 2.315 6.286 2.314 6.275 C 2.295 6.04 2.281 5.864 2.274 5.784 C 2.274 5.781 11.464 5.776 11.464 5.776 L 11.463 5.788 L 11.463 5.796 C 11.462 5.8 11.462 5.811 11.46 5.834 L 11.448 5.987 Z M 4.606 2.369 L 4.706 1.917 C 4.814 1.499 5.146 1.258 5.494 1.258 L 8.245 1.258 C 8.594 1.258 8.926 1.507 9.027 1.885 L 9.133 2.368 L 9.622 2.26 L 9.134 2.368 C 9.27 2.987 9.807 3.446 10.449 3.446 L 12.367 3.446 L 12.367 3.693 L 1.372 3.693 L 1.372 3.446 L 3.291 3.446 C 3.933 3.446 4.469 2.986 4.606 2.369 Z M 12.366 3.436 Z",
    stroke: "#CE1111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBorder);
export default __webpack_public_path__ + "static/media/delete_border.b871a74c6ca2f8a1cc61177a754b1022.svg";
export { ForwardRef as ReactComponent };